import { de_ListEditorDocumentJupyterCellOutputsCommand, se_ListEditorDocumentJupyterCellOutputsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
/**
 * Get the outputs of a code cell of a Jupyter notebook.
 *
 * NOTE: This API is not part of our normal stability guarantees and
 * can change at any moment.
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { Apiv2Client, ListEditorDocumentJupyterCellOutputsCommand } from "@codegrade/apiv2-client"; // ES Modules import
 * // const { Apiv2Client, ListEditorDocumentJupyterCellOutputsCommand } = require("@codegrade/apiv2-client"); // CommonJS import
 * const client = new Apiv2Client(config);
 * const input = { // ListEditorDocumentJupyterCellOutputsRequest
 *   documentId: "STRING_VALUE", // required
 *   cellId: "STRING_VALUE", // required
 *   nextToken: "STRING_VALUE",
 *   pageSize: Number("int"),
 * };
 * const command = new ListEditorDocumentJupyterCellOutputsCommand(input);
 * const response = await client.send(command);
 * // { // ListEditorDocumentJupyterCellOutputsResponse
 * //   outputs: [ // JupyterOutputs // required
 * //     { // JupyterOutput
 * //       jupyterOutputId: "STRING_VALUE", // required
 * //       event: { // JupyterOutputEvent Union: only one key present
 * //         executeStart: { // JupyterExecuteStartOutputEvent
 * //           kernelId: "STRING_VALUE",
 * //           executionCount: Number("int"),
 * //         },
 * //         stream: { // JupyterStreamOutputEvent
 * //           kernelId: "STRING_VALUE",
 * //           name: "STRING_VALUE", // required
 * //           value: { // JupyterStreamOutputEventValue Union: only one key present
 * //             inline: new Uint8Array(),
 * //             link: { // JupyterStreamOutputEventValueLink
 * //               url: "STRING_VALUE", // required
 * //             },
 * //           },
 * //         },
 * //         displayData: { // JupyterDisplayDataOutputEvent
 * //           kernelId: "STRING_VALUE",
 * //           mimeData: { // JupyterMimeOutputDataEvent // required
 * //             "<keys>": { // JupyterMimeOutputDataEventValue Union: only one key present
 * //               inline: new Uint8Array(),
 * //               link: { // JupyterMimeOutputDataEventValueLink
 * //                 url: "STRING_VALUE", // required
 * //               },
 * //             },
 * //           },
 * //           displayId: "STRING_VALUE",
 * //         },
 * //         executeResult: { // JupyterExecuteResultOutputEvent
 * //           kernelId: "STRING_VALUE",
 * //           mimeData: { // required
 * //             "<keys>": {//  Union: only one key present
 * //               inline: new Uint8Array(),
 * //               link: {
 * //                 url: "STRING_VALUE", // required
 * //               },
 * //             },
 * //           },
 * //           executionCount: Number("int"),
 * //         },
 * //         error: { // JupyterErrorOutputEvent
 * //           kernelId: "STRING_VALUE",
 * //           name: "STRING_VALUE", // required
 * //           value: "STRING_VALUE", // required
 * //           traceback: [ // JupyterErrorTracebackOutput // required
 * //             "STRING_VALUE",
 * //           ],
 * //           executionCount: Number("int"),
 * //         },
 * //         executeRequested: { // JupyterExecuteReqeustedOutputEvent
 * //           executionCount: Number("int"),
 * //         },
 * //       },
 * //     },
 * //   ],
 * //   nextToken: "STRING_VALUE",
 * // };
 *
 * ```
 *
 * @param ListEditorDocumentJupyterCellOutputsCommandInput - {@link ListEditorDocumentJupyterCellOutputsCommandInput}
 * @returns {@link ListEditorDocumentJupyterCellOutputsCommandOutput}
 * @see {@link ListEditorDocumentJupyterCellOutputsCommandInput} for command's `input` shape.
 * @see {@link ListEditorDocumentJupyterCellOutputsCommandOutput} for command's `response` shape.
 * @see {@link Apiv2ClientResolvedConfig | config} for Apiv2Client's `config` shape.
 *
 * @throws {@link InternalServerError} (server fault)
 *  An internal failure at the fault of the server.
 *
 * @throws {@link BadRequestError} (client fault)
 *  An error at the fault of the client sending invalid input.
 *
 * @throws {@link NotFoundError} (client fault)
 *  An error due to the client attempting to access a missing
 * resource.
 *
 * @throws {@link NotAuthorizedError} (client fault)
 *  An error due to the client not being authorized to access the
 * resource.
 *
 * @throws {@link NotAuthenticatedError} (client fault)
 *  An error due to the client not being authenticated.
 *
 * @throws {@link ValidationError} (client fault)
 *  A standard error for input validation failures.
 * This should be thrown by services when a member of the input structure
 * falls outside of the modeled or documented constraints.
 *
 * @throws {@link Apiv2ServiceException}
 * <p>Base exception class for all service exceptions from Apiv2 service.</p>
 *
 *
 * @public
 */
export class ListEditorDocumentJupyterCellOutputsCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Apiv2", "ListEditorDocumentJupyterCellOutputs", {})
    .n("Apiv2Client", "ListEditorDocumentJupyterCellOutputsCommand")
    .f(void 0, void 0)
    .ser(se_ListEditorDocumentJupyterCellOutputsCommand)
    .de(de_ListEditorDocumentJupyterCellOutputsCommand)
    .build() {
}
